// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__Idx-e","tab":"Tabs_tab__jFOqL","selected":"Tabs_selected__q569d"};